import { render, staticRenderFns } from "./ReferralProgramCreateForm.vue?vue&type=template&id=210a04f8&"
import script from "./ReferralProgramCreateForm.vue?vue&type=script&lang=js&"
export * from "./ReferralProgramCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports